import './scss/main.scss';
import setupMenuIcon from './setup-menu-icon.js';
import createElement from './util/create-element';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';

const header = document.querySelector('.main-header');

window.addEventListener('scroll', () => {
  const scrollPos = window.scrollY;
  if(scrollPos > 5){
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});

setupMenuIcon(document.querySelector('.menu-icon'));
 
// const links = [
//   {
//     location: '/',
//     label: 'home',
//   },
//   {
//     location: '/contact.html',
//     label: 'contact'
//   },
// ];
// const mainNav = (targetElement, location) => targetElement.appendChild(
//   createElement(
//     'nav', 
//     { style: 'position: fixed; top: 0; left: 0; right: 0; z-index: 1000; background-color: white; color: black;'},
//     [
//       'HI JASON', 
//       createElement(
//         'button', 
//         { onClick: () => alert('woo'), onMouseOver: () => console.log('mouse!') }, 
//         ['what']
//       ),
//       ...links.filter((link) => link.label === 'home' || link.location !== location).map((link) => createElement(
//         'a',
//         { href: link.location },
//         [link.label]
//       ))
//     ]
//   )
// );

// mainNav(document.body, document.location.pathname);